var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008660(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 37,
    viewBox: "0 0 61 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0364 35.5884C22.9603 35.5884 25.3306 33.2181 25.3306 30.2942C25.3306 27.3703 22.9603 25 20.0364 25C17.1125 25 14.7422 27.3703 14.7422 30.2942C14.7422 33.2181 17.1125 35.5884 20.0364 35.5884Z",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.511 35.5884C49.4349 35.5884 51.8052 33.2181 51.8052 30.2942C51.8052 27.3703 49.4349 25 46.511 25C43.5871 25 41.2168 27.3703 41.2168 30.2942C41.2168 33.2181 43.5871 35.5884 46.511 35.5884Z",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8176 30.2895H7.43804C7.08717 30.2895 6.80273 30.0051 6.80273 29.6542V15.7305",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1582 9.11719H14.7466",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5684 9.11719H54.0381C54.2892 9.11719 54.5167 9.265 54.6187 9.49445L59.6904 20.9059C59.7265 20.9872 59.7452 21.0751 59.7452 21.1639V29.6587C59.7452 30.0096 59.4608 30.294 59.1099 30.294H53.1274",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5684 30.293H41.2155",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0418,
    cy: 30.2918,
    r: 4.76447,
    fill: "#F7B53C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5106,
    cy: 30.2918,
    r: 4.76447,
    fill: "#F7B53C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.468 30.2939H38.5711V1.81109C38.5711 1.46019 38.2867 1.17578 37.9358 1.17578H1.51172",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008660);
export default __webpack_public_path__ + "static/media/Group 1000008660.710985612ad7dbd7715f5b1b3c927cd2.svg";
export { ForwardRef as ReactComponent };